import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ReactNode } from 'react';

export const CompanyHubMainLayout: LoadableType<{
	children?: ReactNode | undefined;
}> = LoadablePaint({
	_reactTreeRootForServerPlaceholderId: true,
	name: 'CompanyHubMainLayout',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CompanyHubMainLayout" */ '../src/company-hub/CompanyHubMainLayout.tsx'
			)
		).CompanyHubMainLayout,
});
